import React, { useState, useEffect, memo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styled from 'styled-components'
import FilterColumn from './filter_column'
import { SET_SELECTED_FILTER } from 'estimate_list/reducers/initial'
import { filterTheorem } from 'estimate_list/libs/util'

const FilterOptionAll = () => {
    const selectedFilters = useSelector(state => state.initial.selectedFilters)
    const [word, setWord] = useState('')

    const dispatch = useDispatch()

    useEffect(() => {
        if (!selectedFilters.kwd || selectedFilters.kwd === '') {
            setWord('')
        }
    }, [selectedFilters.kwd])

    const onChangeWord = (e) => {
        setWord(e.target.value)
    }

    const onClickPriceFilter = () => {
        dispatch({
            type: SET_SELECTED_FILTER,
            data: filterTheorem(selectedFilters, {
                kind: 'kwd',
                value: word
            })
        })
        setWord('')
    }

    const onKeyPressPrice = e => {
        if (e.key === 'Enter') {
            onClickPriceFilter()
        }
    }

    return (
        <FilterColumn title="옵션 전체보기" optionAll>
            <div className="row">
                <Inner>
                    <SearchBox>
                        <input
                            type="text"
                            value={word}
                            onChange={onChangeWord}
                            onKeyPress={onKeyPressPrice}
                            onFocus={e => e.target.select()}
                            placeholder="검색어를 입력해 주세요"
                        />
                        <button onClick={onClickPriceFilter}><i className="icon-search1" /></button>
                    </SearchBox>
                </Inner>
            </div>
        </FilterColumn>
    )
}

const Inner = styled.div`
    padding: 0 0 8px;
`

const SearchBox = styled.div`
    position: relative;
    display: inline-block;
    width: 174px;
    height: 25px;
    border: 1px solid #c8c8c8;
    background-color: #fff;
    color: #999;
    margin: 8px 0 0 22px;
    display: inline-block;
    line-height: 25px;
    vertical-align: top;

    input {
        margin: 0 0 0 6px;
        width: 136px;
        height: 23px;
        border: 0;
        line-height: 18px;
        color: #202022;
        vertical-align: top;

        &::placeholder {
            color: #c8c8c8
        }
    }
    button {
        position: absolute;
        top: 0;
        right: 0;
        font-size: 14px;
        color: #c5c5c5;
        width: 30px;
        height: 23px;
    }
`

export default memo(FilterOptionAll)



// WEBPACK FOOTER //
// ./src/estimate_list/components/filter/filter_option_all.js